import { ColumnStoryblok } from "@/types/blok-types";

export default function isOnlyMedia(
  left?: ColumnStoryblok,
  right?: ColumnStoryblok
) {
  const mediaTypes = ["media", "mediaCard", "taggedImage"] as const;
  const l = left?.content?.every((b) =>
    mediaTypes.includes(b.component as (typeof mediaTypes)[number])
  );
  const r = right?.content?.every((b) =>
    mediaTypes.includes(b.component as (typeof mediaTypes)[number])
  );
  return (l && r) ?? false;
}
